import {
    Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Divider,
    Form,
    Input,
    InputNumber,
    message,
    Modal,
    Radio,
    Row,
    Select,
    Spin,
    Tooltip,
    Upload
} from "antd";
import React, {useEffect, useState} from "react";
import {withdraw_template_img, withdraw_title_img} from '../../../AppImageConst';
import {
    DownloadOutlined,
    ExclamationCircleOutlined,
    HistoryOutlined,
    InfoCircleOutlined,
    PlusOutlined
} from "@ant-design/icons";
import './style.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarDays, faGlobe} from "@fortawesome/free-solid-svg-icons";
import {DropdownListDto} from "../../dto/DropdownListDto";
import customerService from "../../service/customerService";
import ErrorHandler from "../../util/ErrorHandler";
import {CustomerDto} from "../../dto/CustomerDto";
import transactionFetchService from "../../service/transactionFetchService";
import {
    INSUFFICIENT_AMOUNT,
    INVALID_AMOUNT,
    LIMIT_YOUR_INPUT,
    MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR,
    MSG_DUPLICATE_TEMPLATE_NAME,
    MSG_ENTER_TEMPLATE_NAME,
    MSG_FAILED_TO_CHECK_TEMPLATE_NAME_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR,
    MSG_FAILED_TO_FETCH_BANK_LIST_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_FUND_AMOUNT_ERROR,
    MSG_FAILED_TO_FETCH_FUND_LIST_ERROR,
    MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR,
    MSG_THIRD_PARTY_BANK_DETAIL_FETCH_ERROR,
    MSG_WITHDRAWAL_FAILURE,
    MSG_WITHDRAWAL_SUCCESS,
    PLEASE_ENTER_AMOUNT,
    PLEASE_ENTER_TRANSFERABLE_AMOUNT
} from "../../util/Messages";
import Validation from "../../util/Validation";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {toNumber} from "lodash";
import CommonFunction from "../../util/CommonFunction";
import dayjs, {Dayjs} from "dayjs";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {
    ACCOUNT_NAME_VALIDATION,
    ALLOWED_ALL_TYPES_TEXT,
    ALLOWED_DOCUMENT_TYPE_EXTENSION,
    ALLOWED_DOCUMENT_TYPES,
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES,
    AMOUNT_VALIDATION,
    COMMON_DROPDOWN,
    DIGITS_AND_DOT_VALIDATION,
    DOCUMENT_TYPES,
    ONLY_NUMERIC_VALIDATION,
    PARAMETER_LIST,
    PREVIEW_DOC_TYPES,
    TRANSACTION_SUMMARY_PAGE_TYPES,
    WITHDRAW_TYPE_TAG,
    YYYY_MM_DD
} from "../../util/Constants";
import {DefaultDocumentDto} from "../../dto/DefaultDocumentDto";
import documentService from "../../service/documentService";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import {TransactionTemplateDto} from "../../dto/TransactionTemplateDto";
import {ThirdPartyBankDetailsDto} from "../../dto/ThirdPartyBankDetailsDto";
import transactionService from "../../service/transactionService";
import modal from "antd/es/modal";
import {TransactionSummaryDto} from "../../dto/TransactionSummaryDto";
import PreviewModalComp from "../../components/common/preview/PreviewModalComp";
import TransactionSummaryPage from "./transactionSummaryPage";
import {getLoggedUserCinNumber} from "../../security/KeyclockConfig";
import accountService from "../../service/accountService";


enum WITHDRAW_TYPE {
    ONLINE = "WITHDRAW_MONEY",
    SWP = "SCHEDULE_WITHDRAW_MONEY",
}

enum WITHDRAW_FREQUENCY_ID {
    ONE_TIME = 1,
    MONTHLY = 2,
}

enum WITHDRAW_FREQUENCY_TAG {
    ONE_TIME = "ONE_TIME",
    MONTHLY = "MONTHLY",
}

enum RECORD_STATUS {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

const OTHER_TYPE = "other"
const OTHER_LABEL = "Other"
const WithdrawTemplatePage = () => {
    const [isLoading] = useState(false);
    const [isThirdPartyBankLoading, setThirdPartyBankLoading] = useState(false);
    const [showOtherBankAccountDiv, setOtherBankAccountShowDiv] = useState<boolean>(false);
    const [isCanShowNewBankDetails, setCanShowNewBankDetails] = useState<boolean>(false);
    const [withdrawalFrequencyValue, setWithdrawalFrequencyValue] = useState(WITHDRAW_FREQUENCY_ID.ONE_TIME);


    const [form] = Form.useForm();
    const [withdrawType, setWithdrawType] = useState<WITHDRAW_TYPE>(WITHDRAW_TYPE.ONLINE);
    const [showSWPDiv, setSWPShowDiv] = useState<boolean>(false);
    const [isThirdPartyBankDisabled, setThirdPartyBankDisabled] = useState<boolean>(false);
    const [portfolioList, setPortfolioList] = useState<DropdownListDto[]>([]);
    const [bankAccountList, setBankAccountList] = useState<DropdownListDto[]>([]);
    const [bankTemplateList, setBankTemplateList] = useState<DropdownListDto[]>([]);
    const [withdrawFrequencyList, setWithdrawFrequencyList] = useState<DropdownListDto[]>([]);
    const [otherBankList, setOtherBankList] = useState<DropdownListDto[]>([]);
    const [otherBankBranchList, setOtherBankBranchList] = useState<DropdownListDto[]>([]);
    const [fundList, setFundList] = useState<DropdownListDto[]>([]);
    const [isSpinning, setSpinning] = useState<boolean>(false);
    const [cinNumber, setCinNumber] = useState<string | null>();
    const [jobNumber, setJobNumber] = useState<number>(0)
    const [isDocumentUploadMandatory, setDocumentUploadMandatory] = useState<boolean>(false);
    const [selectedPortfolioId, setSelectedPortfolioId] = useState<number>(0);
    const [withdrawAmount, setWithdrawAmount] = useState<number>(0);
    const [isSelectFullAmountDisabled, setSelectFullAmountDisabled] = useState<boolean>(true);
    const [isSelectFullAmountSelected, setSelectFullAmountSelected] = useState<boolean>(false);
    const [isCanShowSaveAndSubmit, setCanShowSaveAndSubmit] = useState<boolean>(false);
    const [isCanHideSummery, setCanHideSummery] = useState<boolean>(true);

    const [uploadedDocumentList, setUploadedDocumentList] = useState<DefaultDocumentDto[]>()
    const [uploadDocumentDetailId, setUploadDocumentDetailId] = useState<number>()
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
    const [summaryData, setSummaryData] = useState<TransactionSummaryDto>({} as TransactionSummaryDto);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');

    useEffect(() => {
        setSpinning(true)
        getLoggedUserCIN()
        form.setFieldsValue({withdrawType: WITHDRAW_TYPE.ONLINE})
        setSWPShowDiv(false)
    }, [])

    const onChangeWithdrawType = (e: any) => {
        const checkBoxValue = e.target.value;
        form.setFieldsValue({withdrawType: checkBoxValue})
        setWithdrawType(checkBoxValue);
        setSWPShowDiv(checkBoxValue === WITHDRAW_TYPE.SWP);
    };

    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: ".pdf, .jpeg, .jpg, .png"
    };
    const getLoggedUserCIN = () => {
        let cinNumber = getLoggedUserCinNumber();
        if (undefined != cinNumber) {
            setCinNumber(cinNumber)
            fetchPortfolioList(cinNumber)
            fetchCustomerDetailsByCIN(cinNumber)
        } else {
            customerService.getCustomerCINByLoggedUser().then(async res => {
                let cinNumber = res.data.results;
                setCinNumber(cinNumber)
                await fetchPortfolioList(cinNumber)
                await fetchCustomerDetailsByCIN(cinNumber)
                await fetchBankAccountList(cinNumber)
                await fetchWithdrawFrequencyList()
                setSpinning(false)
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }

    }

    const fetchCustomerDetailsByCIN = (cinNumber: string) => {
        customerService.getExactCustomerByCin(cinNumber).then(res => {
            if (res.data.results.customerMstDto != null) {
                const customerDto = res.data.results.customerMstDto as CustomerDto
                setJobNumber(customerDto.id as number)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const fetchFundList = (portfolioId: number) => {
        // setSpinning(true)
        transactionFetchService.getFundListForSwitchTransferAndWithdrawal(portfolioId).then(res => {
            if (res.data !== null) {
                setFundList(res.data.results)
                // setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_FUND_LIST_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
    }
    const fetchPortfolioList = (cinNumber: string) => {
        if (null != cinNumber) {
            setSpinning(true)
            transactionFetchService.getPortfolioListForSwitchTransferAndWithdrawal(cinNumber).then(res => {
                if (res.data !== null) {
                    setPortfolioList(res.data.results)
                    fetchBankAccountList(cinNumber)
                    fetchWithdrawFrequencyList()
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                    setSpinning(false)
                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        } else {
            console.error("Unable to find cin number.");
        }
    }

    const fetchBankAccountList = (cinNumber: string) => {
        if (null != cinNumber) {
            // setSpinning(true)
            transactionFetchService.getBankAccountList(cinNumber).then(res => {
                if (res.data !== null) {
                    let results: DropdownListDto[] = res.data.results;
                    results.push({value: OTHER_TYPE, label: OTHER_LABEL})
                    setBankAccountList(results)
                    // setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                    setSpinning(false)
                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        } else {
            console.error("Unable to find cin number.");
        }
    }

    const fetchBankTemplateList = (cinNumber: string) => {
        if (null != cinNumber) {
            // setSpinning(true)
            transactionFetchService.getThirdPartyBankTemplateList(cinNumber).then(res => {
                if (res.data !== null) {
                    let results: DropdownListDto[] = res.data.results;
                    results.push({value: OTHER_TYPE, label: OTHER_LABEL})
                    setBankTemplateList(results)
                    // setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                    setSpinning(false)
                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        } else {
            console.error("Unable to find cin number.");
        }
    }

    const fetchWithdrawFrequencyList = () => {
        transactionFetchService.getWithdrawalFrequencyList().then(res => {
            if (res.data !== null) {
                setWithdrawFrequencyList(res.data.results)
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                setSpinning(false)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
    }

    const fetchOtherBankList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }

        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setOtherBankList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const checkDocumentUploadMandatory = (portfolioId: number, cinNumber: string | null | undefined) => {
        if (cinNumber) {
            setSpinning(true)
            transactionFetchService.checkPortfolioJointAndOperatingInstructionsBothParties(portfolioId, cinNumber).then(res => {
                if (res.data !== null) {
                    setDocumentUploadMandatory(res.data.results)
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_FUND_AMOUNT_ERROR).then();
                    setSpinning(false)

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)

            })
        }
    }


    const onChangeFund = (value: number) => {
        fetchAvailableAmount(selectedPortfolioId, value)
    }

    const onChangePortfolio = (value: number) => {
        setSelectedPortfolioId(value)
        fetchFundList(value)
        checkDocumentUploadMandatory(value, cinNumber)
        resetFrom()
    }

    const resetFrom = () => {
        form.resetFields(['withdrawalDate',
            'monthCount',
            'withdrawalFrequency',
            'accountHolderName',
            'accountNo',
            'bankBranch',
            'bankName',
            'templateName',
            'existingTemplate',
            'bankAccount',
            'withdrawAmount',
            'fullAmount',
            'documentUpload',
            'fundId'])
        // form.setFieldsValue({accountType: ACCOUNT_TYPE.OWN})
        // setTransferAccountType(ACCOUNT_TYPE.OWN)
        // setSelectFullAmountDisabled(true)
        // setSelectFullAmountSelected(false)
        setOtherBankAccountShowDiv(false)
        setCanShowNewBankDetails(false)
        if (WITHDRAW_TYPE.SWP != withdrawType) {
            setSWPShowDiv(false)
        }

    }

    const fetchAvailableAmount = (portfolioId: number, fundId: number) => {
        if (0 != portfolioId && 0 != fundId) {
            setSpinning(true)
            transactionFetchService.getAvailableBalance(portfolioId, fundId).then(res => {
                if (res.data !== null) {
                    let amount = res.data.results;
                    setWithdrawAmount(amount)
                    form.setFieldsValue({fullAmount: convertToValue(amount)})
                    form.resetFields(['withdrawAmount'])
                    setSelectFullAmountSelected(false)
                    if (amount > 0) {
                        setSelectFullAmountDisabled(false)
                    } else {
                        setSelectFullAmountDisabled(true)
                    }
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_FUND_AMOUNT_ERROR).then();
                    setSpinning(false)

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)

            })
        }
    }

    const convertToValue = (value: number) => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }

    const onSelectFullAmount = (evt: CheckboxChangeEvent) => {
        setSelectFullAmountSelected(evt.target.checked)
        if (evt.target.checked) {
            form.setFieldsValue({withdrawAmount: convertToValue(withdrawAmount)})
        } else {
            form.resetFields(["withdrawAmount"])
        }
    }

    const validateAmount = (_: any, value: any) => {
        if (!value) {
            return Promise.reject(PLEASE_ENTER_AMOUNT);
        } else if (toNumber(CommonFunction.removeThousandSeparators(value)) <= 0) {
            return Promise.reject(PLEASE_ENTER_TRANSFERABLE_AMOUNT);
        } else if (toNumber(withdrawAmount) < toNumber(CommonFunction.removeThousandSeparators(value))) {
            return Promise.reject(INSUFFICIENT_AMOUNT);
        } else if (CommonFunction.removeThousandSeparators(value).length > 18) {
            return Promise.reject(LIMIT_YOUR_INPUT);
        } else if (!AMOUNT_VALIDATION.test(value)) {
            return Promise.reject(INVALID_AMOUNT);
        } else {
            return Promise.resolve();
        }

    };

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const name = 'withdrawAmount';
        if (withdrawAmount != toNumber(value)) {
            setSelectFullAmountSelected(false)
        }
        if (AMOUNT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)
        } else if (DIGITS_AND_DOT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)

        }
    };
    const formatAndSetAmount = (value: string, name: string) => {
        CommonFunction.toFixedMethod(name, value, form);
        form.validateFields([name]);
    }

    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (AMOUNT_VALIDATION.test(value)) {
            const name = 'withdrawAmount';
            let amount = CommonFunction.removeThousandSeparators(value);
            amount = amount.replace('.00', "")
            form.setFieldsValue({[name]: amount});
            form.validateFields([name]);
        }
    };


    const handleBankSelectChange = (value: string) => {
        if (OTHER_TYPE === value) {
            setOtherBankAccountShowDiv(true);
        } else {
            setOtherBankAccountShowDiv(false);
            setCanShowNewBankDetails(false);
            setCanShowSaveAndSubmit(false);
        }
        form.resetFields(['accountHolderName',
            'accountNo',
            'bankBranch',
            'bankName',
            'templateName',
            'existingTemplate'])
        fetchBankTemplateList(cinNumber as string)
    };


    const handleWithdrawalFrequencySelectChange = (value: any) => {
        setWithdrawalFrequencyValue(value);
        form.resetFields(['withdrawalDate', 'monthCount'])
    };

    const onChangeExistingTemplate = (value: any) => {
        setCanShowNewBankDetails(true);
        setCanShowSaveAndSubmit(value === OTHER_TYPE);
        fetchOtherBankList()
        if (OTHER_TYPE === value) {
            setThirdPartyBankDisabled(false)
            form.resetFields(['accountHolderName', 'accountNo', 'bankBranch', 'bankName', 'templateName'])
        } else {
            setThirdPartyBankLoading(true)
            accountService.fetchExistingBankTemplateById(value).then(res => {
                if (res.data) {
                    form.resetFields(['accountHolderName', 'accountNo', 'bankBranch', 'bankName', 'templateName'])
                    let results = res.data.results;
                    setThirdPartyBankDisabled(true)
                    getBranchList(results.bankCode)
                    form.setFieldsValue({
                        accountHolderName: results.accountName,
                        accountNo: results.accountNo,
                        bankBranch: results.branchId,
                        bankName: results.bankCode,
                        templateName: results.accountNickName,
                    })
                    setThirdPartyBankLoading(false)
                } else {
                    message.error(MSG_THIRD_PARTY_BANK_DETAIL_FETCH_ERROR)
                    setThirdPartyBankLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setThirdPartyBankDisabled(true)
            });
        }
    };

    const enabledDates = [
        1, 7, 15, 20, 25, 30
    ];

    const getLastDayOfMonth = (date: Dayjs) => {
        return dayjs(date).endOf('month').date();
    };

    const disabledDate = (current: any) => {
        const currentDate = dayjs(current);
        const currentDateOfMonth = currentDate.date();
        const lastDayOfMonth = getLastDayOfMonth(currentDate);

        if (currentDate.isBefore(dayjs(), 'day')) {
            return true;
        }
        if ((enabledDates.includes(currentDateOfMonth)) ||
            (currentDateOfMonth === lastDayOfMonth && currentDate.month() === 1)) {
            return false;
        }

        return true;
    };

    const onChangeOtherBank = (value: number) => {
        clearBankRelatedFields()
        getBranchList(value)
    }

    const clearBankRelatedFields = () => {
        form.resetFields(["bankBranch", "accountNo", "accountHolderName"])
    }

    const getBranchList = (selectedBank: number) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setOtherBankBranchList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const validateMonthCount = (value: any) => {
        const monthCount = form.getFieldValue("monthCount")
        if (monthCount > 120) {
            return Promise.reject(new Error('Ensure month count is ≤ 120'));
        } else {
            return Promise.resolve();
        }
    };

    const validateTemplateName = (rule: any, value: any, callback: any) => {
        if (value) {
            if (OTHER_TYPE != value && OTHER_LABEL != value) {
                transactionFetchService.validateThirdPartyBankTemplateName(value, cinNumber as string).then(res => {
                    if (res.data !== null) {
                        if (res.data.results) {
                            callback(MSG_DUPLICATE_TEMPLATE_NAME)
                        } else {
                            callback()
                        }
                    } else {
                        message.error(MSG_FAILED_TO_CHECK_TEMPLATE_NAME_ERROR).then();
                        callback(MSG_FAILED_TO_CHECK_TEMPLATE_NAME_ERROR)
                    }

                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    callback()
                })
            } else {
                callback(MSG_DUPLICATE_TEMPLATE_NAME)
            }
        } else {
            callback(MSG_ENTER_TEMPLATE_NAME)
        }
    };

    const onRemove = () => {
        setSpinning(true)
        if (uploadedDocumentList) {
            documentService.deleteDocumentById(uploadedDocumentList[0].uid).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList([])
                    setUploadDocumentDetailId(undefined)
                    form.setFieldsValue({documentUpload: undefined})
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                    setSpinning(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        }

        return true;
    };

    const beforeUploadDocument = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.WTD, ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES));
    };

    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setSpinning(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", JSON.stringify(jobNumber));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, false)
                setUploadDocumentDetailId(uploadDocumentDetailDto.uploadDocumentDetailId)
                setSpinning(false)
            } else {
                setSpinning(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinning(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number, init: boolean) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.WTD) {
            setUploadedDocumentList(defaultFileList)
            form.setFieldsValue({documentUpload: defaultFileList})

        }
    };

    const onSubmit = (buttonType: RECORD_STATUS) => {
        form.validateFields().then(() => {

            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure?, Do you want to withdraw money${RECORD_STATUS.ACTIVE == buttonType ? ' and save the template?' : '?'}`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    setSpinning(true)
                    let values = form.getFieldsValue()
                    let transactionTemplateDto: TransactionTemplateDto = {};
                    transactionTemplateDto.transactionDocumentId = uploadDocumentDetailId
                    transactionTemplateDto.portfolioId = values.portfolioId
                    transactionTemplateDto.fundId = values.fundId
                    transactionTemplateDto.withdrawAmount = toNumber(CommonFunction.removeThousandSeparators(values.withdrawAmount))
                    transactionTemplateDto.bankAccountId = OTHER_TYPE === values.bankAccount ? null : values.bankAccount
                    transactionTemplateDto.withdrawalMethod = values.withdrawType
                    transactionTemplateDto.fullAmountSelection = isSelectFullAmountSelected

                    if (showOtherBankAccountDiv) {
                        transactionTemplateDto.thirdPartyBankAccountId = OTHER_TYPE === values.existingTemplate ? null : values.existingTemplate
                        if (isCanShowNewBankDetails) {
                            transactionTemplateDto.thirdPartyBankDetailsDto = {
                                cin: cinNumber,
                                accountName: values.accountHolderName,
                                accountNickName: values.templateName,
                                accountNo: values.accountNo,
                                bankCode: values.bankName,
                                branchId: values.bankBranch,
                                accountStatus: buttonType
                            } as ThirdPartyBankDetailsDto
                        }
                    }

                    if (WITHDRAW_TYPE.SWP === values.withdrawType) {

                        transactionTemplateDto.withdrawalFrequency = WITHDRAW_FREQUENCY_ID.ONE_TIME === values.withdrawalFrequency ? WITHDRAW_FREQUENCY_TAG.ONE_TIME : WITHDRAW_FREQUENCY_TAG.MONTHLY
                        transactionTemplateDto.withdrawalFrequencyId = values.withdrawalFrequency
                        transactionTemplateDto.scheduledDate = dayjs(values.withdrawalDate).format(YYYY_MM_DD)
                        transactionTemplateDto.fullAmountSelection = false
                        if (WITHDRAW_FREQUENCY_ID.MONTHLY === values.withdrawalFrequency) {
                            transactionTemplateDto.withdrawalMonthCount = values.monthCount
                        }
                    }


                    transactionService.withdrawMoney(transactionTemplateDto).then((res) => {
                        if (res.data.results) {
                            message.success(MSG_WITHDRAWAL_SUCCESS)
                            setSummaryDataToState(res.data.results.transactionTemplateDto)
                            setSpinning(false)
                            setUploadedDocumentList([])
                            setFundList([])
                            form.resetFields()
                            setUploadDocumentDetailId(undefined)
                            setSelectedPortfolioId(0)
                            setSelectFullAmountDisabled(true)
                            setSelectFullAmountSelected(false)
                            setOtherBankAccountShowDiv(false)
                            setCanShowNewBankDetails(false)
                            setCanHideSummery(false)
                            form.setFieldsValue({withdrawType: WITHDRAW_TYPE.ONLINE})
                            setSWPShowDiv(false);
                            setWithdrawalFrequencyValue(WITHDRAW_FREQUENCY_ID.ONE_TIME);
                        } else {
                            message.error(MSG_WITHDRAWAL_FAILURE)
                            setSpinning(false)
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setSpinning(false)

                    })
                },
                onCancel() {

                }
            });
        }).catch(() => {

        })
    }

    const setSummaryDataToState = (data: TransactionTemplateDto) => {
        let transactionData: TransactionSummaryDto = {
            portfolio: data.portfolioNumber,
            fund: data.fundName,
            withdrawAmount: CommonFunction.currencyFormat(data.withdrawAmount),
            jobNumber: jobNumber,
            documentId: data.transactionDocumentId as number,
            withdrawalFrequency: WITHDRAW_FREQUENCY_TAG.MONTHLY === data.withdrawalFrequency ? "Monthly" : "One Time",
            withdrawalMethod: WITHDRAW_TYPE_TAG.SCHEDULE_WITHDRAW_MONEY_SWP === data.withdrawalMethod ? "SWP" : WITHDRAW_TYPE_TAG.SCHEDULE_WITHDRAW_MONEY_SCHEDULED === data.withdrawalMethod ? "Scheduled" : "Online",
            withdrawalMonthCount: data.withdrawalMonthCount,
            scheduledDate: data.scheduledDate,
            bankAccount: null == data.bankAccount ? OTHER_LABEL : data.bankAccount,
            refNumber: data.autoGeneratedRefNo,
            processingDate: data.processDate,
            existingTemplate: null == data.thirdPartyBankAccountId ? OTHER_LABEL : data.thirdPartyBankDetailsDto?.accountNickName,
            isCanShowNewBankDetails: false,
        };

        if (null == data.thirdPartyBankAccountId && null != data.thirdPartyBankDetailsDto) {
            transactionData.templateName = data.thirdPartyBankDetailsDto?.accountNickName
            transactionData.bankName = data.thirdPartyBankDetailsDto?.bankName
            transactionData.branch = data.thirdPartyBankDetailsDto?.branchName
            transactionData.accountNumber = data.thirdPartyBankDetailsDto?.accountNo
            transactionData.accountHolderName = data.thirdPartyBankDetailsDto?.accountName
            transactionData.accountStatus = data.thirdPartyBankDetailsDto?.accountStatus
            transactionData.isCanShowNewBankDetails = true
        }

        setSummaryData(transactionData)
    }

    const onClose = () => {
        form.resetFields()
        setCanHideSummery(true)
        setUploadedDocumentList([])
        setFundList([])
        setUploadDocumentDetailId(undefined)
        setSelectedPortfolioId(0)
        setSelectFullAmountDisabled(true)
        setSelectFullAmountSelected(false)
        setOtherBankAccountShowDiv(false)
        setCanShowNewBankDetails(false)
        form.setFieldsValue({withdrawType: WITHDRAW_TYPE.ONLINE})
        setSWPShowDiv(false);
        setWithdrawalFrequencyValue(WITHDRAW_FREQUENCY_ID.ONE_TIME);
    }

    const onPreview = (documentId: string, docTypeName: string) => {
        setSpinning(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(CommonFunction.checkDocumentContentType(res.data.results))
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
        return true;
    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };

    const navigateHistory = () => {
        window.open("/workflow/customer/transaction-history/" + "withdraw-transactions", "_blank")
    }

    const handleDateChange = (values: any) => {
        console.log(values)
    }
    return (
        <Spin spinning={isLoading}>
            <Row gutter={[40, 0]} className={'right-side-container-margin disabled-data-show-inputs-container'}>
                <Col lg={10} md={10} sm={0}
                     className={'left-side-main-container left-side-main-container-inside-dashboard'}>
                    <Row>
                        <Col span={24}>
                            <div className="clip-path-img">
                                <div className='clip-path-img-container'>
                                    <img src={withdraw_template_img} alt="logo"/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                {isCanHideSummery ?
                    <Col lg={14} md={14} sm={24}
                         className='right-side-main-container-inside-dashboard scroll-right-side align-div-center dashboard-right-side-contaner-scroll layout-bottom-space'>
                        <Form
                            className='form-input'
                            layout={"vertical"}
                            form={form}
                        >
                            <div className='account_type_container second-applicant-details' style={{paddingTop: 16}}>
                                <div>
                                    <Row gutter={[32, 0]}>
                                        <Col xs={18} sm={18} md={18} lg={18} xl={18}
                                             className='page-header-main-title-col'>
                                            <h2 className='page-header-main-title'
                                                style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                                <div className='header_icon header-icon-center'>
                                                    <img style={{height: 24, width: 24}} src={withdraw_title_img}
                                                         alt=""/>
                                                </div>
                                                Withdraw Money
                                            </h2>
                                        </Col>
                                        <Col xs={6} sm={6} md={6} lg={6} xl={6} className='view-tr-history-btn-col'>
                                            <Button onClick={navigateHistory}
                                                    size={'small'} className={'view-tr-history-btn'}
                                                    icon={<HistoryOutlined/>}>View History</Button>

                                        </Col>
                                    </Row>
                                    <Spin size="large" tip="Loading" spinning={isSpinning}>
                                        <Card className={'template_card'}>
                                            <Row gutter={[32, 0]}>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label="Withdraw Type"
                                                        name={"withdrawType"}
                                                        rules={
                                                            [{
                                                                required: true,
                                                                message: 'Please select withdraw type'
                                                            }]}>
                                                        <Radio.Group optionType="button"
                                                                     buttonStyle="solid"
                                                                     className='template-screen-radio-btn'
                                                                     onChange={onChangeWithdrawType}
                                                                     value={withdrawType}
                                                        >

                                                            <Radio.Button value={WITHDRAW_TYPE.ONLINE}><FontAwesomeIcon
                                                                icon={faGlobe}
                                                                className='radio-btn-icon'/> Online</Radio.Button>
                                                            <Radio.Button value={WITHDRAW_TYPE.SWP}><FontAwesomeIcon
                                                                icon={faCalendarDays}
                                                                className='radio-btn-icon'/> Schedule/SWP</Radio.Button>

                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label="Portfolio ID"
                                                        name={"portfolioId"}
                                                        rules={
                                                            [{required: true, message: 'Please select portfolio'}]}>
                                                        <Select placement='bottomLeft' listHeight={180}
                                                                placeholder={"Select portfolio"}
                                                                getPopupContainer={(trigger: {
                                                                    parentNode: any;
                                                                }) => trigger.parentNode}
                                                                style={{width: '100%'}}
                                                                options={portfolioList}
                                                                onChange={onChangePortfolio}
                                                                size={'large'}
                                                        >
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label="Fund"
                                                        name={"fundId"}
                                                        rules={
                                                            [{required: true, message: 'Please select fund'}]}>
                                                        <Select placement='bottomLeft' listHeight={180}
                                                                placeholder={"Select fund"}
                                                                getPopupContainer={(trigger: {
                                                                    parentNode: any;
                                                                }) => trigger.parentNode}
                                                                style={{width: '100%'}}
                                                                options={fundList}
                                                                onChange={onChangeFund}
                                                                size={'large'}
                                                        >
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label={"Full Amount"}
                                                        name={"fullAmount"}>

                                                        <Input step="0.00"
                                                               size={'large'} disabled
                                                        />

                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    {!showSWPDiv ?
                                                        <Checkbox className='full_amount_checkbox'
                                                                  disabled={isSelectFullAmountDisabled}
                                                                  checked={isSelectFullAmountSelected}
                                                                  onChange={onSelectFullAmount}>
                                                            <span className="full_amount_txt">
                                                                Select the Full Amount
                                                            </span>
                                                            <Tooltip
                                                                title="A full amount withdraw represents the total value available on the transaction date"
                                                                placement={'top'}>
                                                                <InfoCircleOutlined style={{
                                                                    fontSize: 18,
                                                                    marginLeft: 10,
                                                                    color: '#108ee9'
                                                                }}/>
                                                            </Tooltip>
                                                        </Checkbox> : <></>}
                                                    <Form.Item
                                                        label={<><span className='custom-astrix'>*</span> Amount</>}
                                                        name={'withdrawAmount'}
                                                        // validateTrigger={["onBlur"]}
                                                        rules={[{validator: validateAmount}]}>
                                                        <Input onKeyPress={Validation.isNumber}
                                                            // maxLength={15}
                                                               size={'large'}
                                                               onBlur={handleBlur}
                                                               onFocus={handleFocus}
                                                               autoComplete="off"
                                                               placeholder={"Enter amount"}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label="Bank Account"
                                                        name={'bankAccount'}
                                                        rules={
                                                            [{required: true, message: 'Please select bank account'}]}>
                                                        <Select placement='bottomLeft' listHeight={180}
                                                                placeholder={"Select bank account"}
                                                                getPopupContainer={(trigger: {
                                                                    parentNode: any;
                                                                }) => trigger.parentNode}
                                                                style={{width: '100%'}}
                                                                options={bankAccountList}
                                                                onChange={handleBankSelectChange}
                                                                size={'large'}
                                                        >
                                                        </Select>

                                                    </Form.Item>
                                                </Col>

                                                {showOtherBankAccountDiv && (
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label="Existing Template"
                                                            name={'existingTemplate'}
                                                            rules={
                                                                [{
                                                                    required: true,
                                                                    message: 'Please select existing template'
                                                                }]}>
                                                            <Select placeholder={"Select existing template"}
                                                                    size={'large'}
                                                                    onChange={onChangeExistingTemplate}
                                                                    getPopupContainer={(trigger: {
                                                                        parentNode: any;
                                                                    }) => trigger.parentNode}
                                                                    style={{width: '100%'}}
                                                                    options={bankTemplateList}

                                                            >
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                )}

                                                {/*---*/}

                                                {isCanShowNewBankDetails ?
                                                    <>
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            <Divider orientation="left" orientationMargin="0"
                                                                     style={{color: '#008D86', marginTop: 6}}>
                                                                {isThirdPartyBankDisabled ? 'Third Party Bank Template' : 'New Bank Details'}
                                                            </Divider>
                                                        </Col>
                                                        <Spin spinning={isThirdPartyBankLoading}>
                                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                <Row gutter={16}>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <Form.Item
                                                                            label={
                                                                                !isThirdPartyBankDisabled ?
                                                                                    <>
                                                                                <span
                                                                                    className='custom-astrix-pw-change'>*
                                                                                </span> Template Name
                                                                                    </> : <>Template Name</>
                                                                            }

                                                                            name={"templateName"}
                                                                            validateTrigger={["onBlur"]}
                                                                            rules={!isThirdPartyBankDisabled ? [{validator: validateTemplateName}] : []}>
                                                                            <Input size={'large'}
                                                                                   placeholder={"Enter template name"}
                                                                                   disabled={isThirdPartyBankDisabled}/>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <Form.Item
                                                                            label="Name of the Bank"
                                                                            name={'bankName'}
                                                                            rules={
                                                                                !isThirdPartyBankDisabled
                                                                                    ? [{
                                                                                        required: true,
                                                                                        message: 'Please select the bank name'
                                                                                    }] : []}>

                                                                        <Select placement='bottomLeft'
                                                                                    onChange={onChangeOtherBank}
                                                                                    placeholder={"Select bank name"}
                                                                                    showSearch listHeight={180}
                                                                                    optionFilterProp="children"
                                                                                    filterOption={(input: any, option: {
                                                                                        label: any;
                                                                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                                                    getPopupContainer={(trigger: {
                                                                                        parentNode: any;
                                                                                    }) => trigger.parentNode}
                                                                                    options={otherBankList}
                                                                                    size={'large'}
                                                                                    style={{width: '100%'}}
                                                                                    disabled={isThirdPartyBankDisabled}
                                                                            />

                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <Form.Item
                                                                            label="Branch"
                                                                            name={'bankBranch'}
                                                                            rules={
                                                                                !isThirdPartyBankDisabled
                                                                                    ? [{
                                                                                        required: true,
                                                                                        message: 'Please select the branch'
                                                                                    }] : []
                                                                            }>

                                                                            <Select placement='bottomLeft'
                                                                                        defaultSelected={""}
                                                                                        placeholder={"Select branch"}
                                                                                        showSearch
                                                                                        listHeight={180}
                                                                                        optionFilterProp="children"
                                                                                        filterOption={(input: any, option: {
                                                                                            label: any;
                                                                                        }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                                                        getPopupContainer={(trigger: {
                                                                                            parentNode: any;
                                                                                        }) => trigger.parentNode}
                                                                                        options={otherBankBranchList}
                                                                                        size={'large'}
                                                                                        style={{width: '100%'}}
                                                                                        disabled={isThirdPartyBankDisabled}
                                                                                />
                                                                            </Form.Item>
                                                                    </Col>

                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <Form.Item
                                                                            label="Account Number"
                                                                            name={"accountNo"}
                                                                            onKeyPress={Validation.isNumberWithoutDot}
                                                                            rules={
                                                                                !isThirdPartyBankDisabled
                                                                                    ? [
                                                                                        {
                                                                                            required: true,
                                                                                            message: 'Please enter account number',
                                                                                        },
                                                                                        {
                                                                                            max: 30,
                                                                                            message: 'The maximum length is 30 numbers',
                                                                                        },
                                                                                        {
                                                                                            pattern: ONLY_NUMERIC_VALIDATION,
                                                                                            message: 'These special characters are not allowed',
                                                                                        },
                                                                                    ]
                                                                                    : []
                                                                            }>

                                                                        <Input size={'large'}
                                                                                   placeholder={"Enter account number"}
                                                                                   disabled={isThirdPartyBankDisabled}/>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <Form.Item
                                                                            label="Account Holder`s Name"
                                                                            name={"accountHolderName"}
                                                                            onKeyPress={Validation.onlyAlphabeticWithSpace}
                                                                            rules={
                                                                                !isThirdPartyBankDisabled
                                                                                    ? [
                                                                                        {
                                                                                            required: true,
                                                                                            message: 'Please enter account holder`s name'
                                                                                        },
                                                                                        {
                                                                                            max: 50,
                                                                                            message: 'The maximum length is 50 characters'
                                                                                        },
                                                                                        {
                                                                                            pattern: ACCOUNT_NAME_VALIDATION,
                                                                                            message: 'Special characters and numbers are not allowed'
                                                                                        }
                                                                                    ] : []}>

                                                                            <Input type="text"
                                                                                       size={'large'}
                                                                                       placeholder={"Enter account holder`s name"}
                                                                                       disabled={isThirdPartyBankDisabled}/>
                                                                        </Form.Item>

                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Spin>
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            <Divider style={{marginTop: 6}}>
                                                            </Divider>
                                                        </Col>
                                                    </> : <></>}
                                                {/*---*/}


                                                {showSWPDiv && (
                                                    <>
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            <Row gutter={16}>
                                                                <Col xs={24} sm={24}
                                                                     md={withdrawalFrequencyValue === WITHDRAW_FREQUENCY_ID.ONE_TIME ? 24 : 12}
                                                                     lg={withdrawalFrequencyValue === WITHDRAW_FREQUENCY_ID.ONE_TIME ? 24 : 12}
                                                                     xl={withdrawalFrequencyValue === WITHDRAW_FREQUENCY_ID.ONE_TIME ? 24 : 12}
                                                                     xxl={withdrawalFrequencyValue === WITHDRAW_FREQUENCY_ID.ONE_TIME ? 24 : 16}>
                                                                    <Form.Item
                                                                        label="Withdrawal Frequency"
                                                                        name={'withdrawalFrequency'}
                                                                        rules={
                                                                            [{
                                                                                required: true,
                                                                                message: 'Please select withdrawal frequency'
                                                                            }]}>
                                                                        <Select
                                                                            placeholder={"Select withdrawal frequency"}
                                                                            size={'large'}
                                                                            onChange={handleWithdrawalFrequencySelectChange}
                                                                            value={withdrawalFrequencyValue}
                                                                            style={{width: '100%'}}
                                                                            options={withdrawFrequencyList}

                                                                        >
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                                {
                                                                    withdrawalFrequencyValue === WITHDRAW_FREQUENCY_ID.MONTHLY ?
                                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}
                                                                             xxl={8}>
                                                                            <Form.Item
                                                                                label="Month Count"
                                                                                name={"monthCount"}
                                                                                rules={
                                                                                    [{
                                                                                        required: true,
                                                                                        message: 'Please enter month count'
                                                                                    },
                                                                                        {validator: validateMonthCount}
                                                                                    ]}
                                                                            >
                                                                                <InputNumber
                                                                                    style={{width: '100%'}}
                                                                                    size={'large'}
                                                                                    placeholder={'Enter month count'}
                                                                                    min="0"
                                                                                    controls={false}/>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        : ''
                                                                }

                                                            </Row>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                            <Form.Item
                                                                label="Withdrawal Date"
                                                                name={'withdrawalDate'}
                                                                rules={
                                                                    [{
                                                                        required: true,
                                                                        message: 'Please select withdrawal date'
                                                                    }]}>
                                                                {/*<DatePicker size={'large'}*/}
                                                                {/*            placeholder={'Select withdrawal date'}*/}
                                                                {/*            style={{width: '100%'}}/>*/}
                                                                {WITHDRAW_FREQUENCY_ID.ONE_TIME === withdrawalFrequencyValue ?
                                                                    <DatePicker size={'large'}
                                                                                showToday={false}
                                                                                disabledDate={(d: {
                                                                                    isBefore: (arg0: dayjs.Dayjs) => any
                                                                                }) => !d || d.isBefore(dayjs())}
                                                                                onChange={handleDateChange}

                                                                                placeholder={'Select withdrawal date'}
                                                                                style={{width: '100%'}}/>
                                                                    :
                                                                    <DatePicker
                                                                        size={'large'}
                                                                        style={{width: '100%'}}
                                                                        placeholder={'Select withdrawal date'}
                                                                        onChange={handleDateChange}
                                                                        disabledDate={disabledDate}
                                                                    />}
                                                            </Form.Item>
                                                        </Col>
                                                    </>

                                                )}


                                                {/*show below form items if select new account from above options */}

                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        label="Upload a Document"
                                                        name={'documentUpload'}
                                                        rules={
                                                            [{
                                                                required: isDocumentUploadMandatory,
                                                                message: 'Please upload a document'
                                                            }]}>
                                                        <Upload {...configs}
                                                                className='upload_comp'
                                                                accept={ALLOWED_IMAGE_TYPE_EXTENSION.concat(", " + ALLOWED_DOCUMENT_TYPE_EXTENSION)}
                                                                listType="picture"
                                                                onPreview={(e: any) => {
                                                                    onPreview(uploadedDocumentList ? uploadedDocumentList[0].uid : '',
                                                                        uploadedDocumentList ? uploadedDocumentList[0].name : '')
                                                                }}
                                                                onRemove={onRemove}
                                                                fileList={uploadedDocumentList && uploadedDocumentList?.length > 0 ? uploadedDocumentList : undefined}
                                                                beforeUpload={beforeUploadDocument}
                                                        >
                                                            {(undefined != uploadedDocumentList ? uploadedDocumentList.length : [].length) < 1 &&
                                                                <Button>
                                                                    <div className='upload-btn-div'>
                                                                        <div className="upload-icon-div">
                                                                            <PlusOutlined
                                                                                style={{
                                                                                    fontSize: 20,
                                                                                    color: '#757575'
                                                                                }}/>
                                                                        </div>
                                                                        <div className="upload-btn-text-div">
                                                                <span>
                                                                    Document {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                        </div>
                                                                    </div>
                                                                </Button>
                                                            }
                                                        </Upload>
                                                    </Form.Item>
                                                </Col>

                                            </Row>
                                        </Card>
                                    </Spin>
                                </div>
                                <div>
                                    <Row gutter={[32, 0]}>

                                        <Col sm={24} lg={{span: 12, offset: 12}}
                                             className='continue-btn-col text-right withdraw-template-submit-btns'>
                                            {isCanShowSaveAndSubmit ?
                                                <Form.Item className='form-item-btn' style={{marginRight: 16}}>
                                                    <Button type="primary" ghost
                                                            onClick={() => onSubmit(RECORD_STATUS.ACTIVE)}
                                                            disabled={isSpinning}
                                                            className='custom-btn-primary-ghost ant-btn margin_top_20'>
                                                        Save & Submit
                                                    </Button>
                                                </Form.Item>
                                                :
                                                <></>}
                                            <Form.Item className='form-item-btn'>
                                                {/*Redirect to the summary page*/}
                                                <Button type="primary" value={"INACTIVE"}
                                                        onClick={() => onSubmit(RECORD_STATUS.INACTIVE)}
                                                        disabled={isSpinning}
                                                        className='custom-btn-primary ant-btn margin_top_20'>
                                                    Submit
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                    </Row>
                                </div>
                            </div>
                        </Form>
                        <Modal
                            className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                            open={previewOpen}
                            centered
                            title={previewTitle}
                            onCancel={handlePreviewCancel}
                            destroyOnClose={true}
                            width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                            footer={[
                                <Button type="primary" icon={<DownloadOutlined/>}
                                        style={{background: '#FF7400', height: 40}}
                                        htmlType="submit" onClick={() => CommonFunction.download(docURL, previewTitle)}>
                                    Download
                                </Button>]}>
                            <PreviewModalComp docURL={docURL}/>
                        </Modal>
                    </Col> : <TransactionSummaryPage summaryData={summaryData} onClose={onClose}
                                                     summaryPageType={TRANSACTION_SUMMARY_PAGE_TYPES.WITHDRAW}/>}
            </Row>

        </Spin>
    )

}
export default WithdrawTemplatePage;

